import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { Thumbs } from '@/components/Icons/Thumbs';
import styles from './FeedbackMessage.module.scss';
export const FeedbackMessage = ({ clicked, handleClick }) => {
    const { t } = useTranslation();
    return (_jsxs("div", { className: cn(styles.feedback, {
            [styles.hasBeenSelected]: clicked !== null,
        }), children: [_jsxs("p", { children: [t('feedback.helpful'), " "] }), _jsxs("div", { className: cn(styles.thumbsContainer), children: [_jsx("button", { className: cn(styles.buttonContainer, {
                            [styles.clicked]: clicked === 0,
                        }), onClick: () => handleClick(1), children: _jsx(Thumbs, { orientation: "up", size: 18 }) }), _jsx("button", { className: cn(styles.buttonContainer, {
                            [styles.clicked]: clicked === 1,
                        }), onClick: () => handleClick(-1), children: _jsx(Thumbs, { size: 18 }) })] })] }));
};
